import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

class ProfileNav extends Component {
  static propTypes = {
    selectedParticipation: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired
  }

  render() {
    const { profile, selectedParticipation } = this.props;

    return (
      <div className='profile-nav'>
        {profile.participations.map((participation) => (
          <Link
            className={participation === selectedParticipation ?  "menu-item active": "menu-item"}
            key={participation.id}
            to={`/${profile.username}/${participation.sport_slug}/profile`}
          >
              {participation.sport_name}
          </Link>
        ))}
      </div>
    )
  }
}

export default ProfileNav;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileNav.js